import { Injectable } from '@angular/core';
import { HttpRequestModel, HttpService } from '../httpservice/http.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class JobsService {
  HttpRequestModel: HttpRequestModel = new HttpRequestModel();

  constructor(private httpService: HttpService) { }

  //Request to get all jobs
  getJobs(searchInfo = null, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_jobs';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = searchInfo;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  getAllJobs(searchInfo = null, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_jobs/sub_jobs';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = { ...searchInfo, noGroup: true };

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to get all jobs
  getInvoiceJobs(searchInfo = null, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_jobs/getInvoiceData';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = searchInfo;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to get filter year
  getYearsFilter(showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_jobs/yearFilter';
    this.HttpRequestModel.method = 'GET';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to get specific job by id
  getJobById(id, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_jobs/' + id;
    this.HttpRequestModel.method = 'GET';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to create job
  createJob(jobInfo, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_jobs/add';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = jobInfo;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to get latest one job
  getJobLastEntry(showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_jobs/get_last_entry';
    this.HttpRequestModel.method = 'GET';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to update job
  updateJobById(jobId, jobData, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_jobs/update/' + jobId;
    this.HttpRequestModel.method = 'PUT';
    this.HttpRequestModel.body = jobData;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to create sage export
  getSageExport(jobData, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_jobs/get_sage_export';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = jobData;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to get all media for a job, optionally filtered by category
  getJobMedia(jobId, category?: string, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = `potential_jobs/${jobId}/media${category ? '?category=' + category : ''}`;
    this.HttpRequestModel.method = 'GET';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to download sage export PDF directly
  downloadSageExport(jobData, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_jobs/download_sage_export';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = jobData;
    this.HttpRequestModel.responseType = 'blob';
    this.HttpRequestModel.observe = 'response';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to delete job by id
  deleteJob(jobId, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_jobs/delete/' + jobId;
    this.HttpRequestModel.method = 'DELETE';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to get all arcustomer
  getARCustomer(arCustomerSearch = null, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'ar_customers/getFromModel';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = arCustomerSearch;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to get arcustomer by id
  getARCustomerById(arCustomerId, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'ar_customers/detail/' + arCustomerId;
    this.HttpRequestModel.method = 'GET';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to update arcustomer by id
  updateARCustomerById(arCustomerData, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'ar_customers/update';
    this.HttpRequestModel.method = 'PUT';
    this.HttpRequestModel.body = [arCustomerData];

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to get all union locals
  getUnionLocals(showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'locals';
    this.HttpRequestModel.method = 'GET';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to delete department job by id
  deleteDepartment(departmentId, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_jobs/delete_department/' + departmentId;
    this.HttpRequestModel.method = 'DELETE';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  getJobDepartment(job_id, department_id, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_jobs/job_department';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = {
      job_id: job_id,
      department_id: department_id,
    };

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  getJobTableFilters(
    jobTypes: string[],
    showLoader = false,
    hideLoader = false,
    additionalParams?: Record<string, unknown>,
  ): Observable<unknown> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_jobs/get_job_table_filters';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = {
      jobTypes,
      limit: 1000,
      start: 0,
    };

    if (additionalParams) {
      this.HttpRequestModel.body = {
        ...this.HttpRequestModel.body,
        ...additionalParams,
      };
    }

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to get all jobs
  exportJobs(searchInfo = null, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_jobs/export';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = searchInfo;
    this.HttpRequestModel.responseType = 'blob';
    this.HttpRequestModel.observe = 'response';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }
}
